import AlertCircleIcon from 'app/ui/icons/AlertCircleIcon';

import { Box, CircularProgress, LinearProgress } from '@mui/material';

import { FileInfo } from '../multi-file-uploader2/MultiFileUploader2';
import CancelButton from './CancelButton';
import RetryButton from './RetryButton';

export interface UploadActionsProps {
  item: FileInfo;
  onCancel?: (id: string) => void;
  onRetry?: (id: string) => void;
}

export default function UploadActions(props: UploadActionsProps) {
  const { item, onCancel, onRetry } = props;

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-start" width="100%" minHeight={56}>
      <Box mr={1.5}>
        {item.state !== 'error' && item.state !== 'cancelled' && <CircularProgress color="secondary" size={20} />}
        {(item.state === 'error' || item.state === 'cancelled') && <AlertCircleIcon color="secondary" />}
      </Box>
      <Box mr={1.5} fontSize="1.6rem" flex="1" overflow="hidden">
        {item.state === 'error' && (
          <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden" color="#d50037">
            Error uploading file {item.name}
          </Box>
        )}
        {item.state === 'saving' && (
          <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
            Saving {item.name}
          </Box>
        )}
        {item.state === 'uploading' && (
          <>
            <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
              Uploading {item.name}
            </Box>
            <Box width={'100%'}>
              <LinearProgress variant="determinate" value={item.uploadProgress} />
            </Box>
          </>
        )}
        {item.state === 'removing' && (
          <Box textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
            Removing {item.name}
          </Box>
        )}
      </Box>
      {['error'].includes(item.state) && (
        <Box mr={1}>
          <RetryButton onAction={() => onRetry && onRetry(item.uppyId || '')} />
        </Box>
      )}
      {!['removing', 'saving'].includes(item.state) && (
        <CancelButton onAction={() => onCancel && onCancel(item.uppyId || '')} />
      )}
    </Box>
  );
}
